import React from 'react';

import Layout from '../layouts/LoginLayout';
import { ResetPasswordForm } from '@repo/auth/components/ResetPasswordForm';

const passwordLoginEndpoint = import.meta.env.VITE_PASSWORD_LOGIN_ENDPOINT!;

const ResetPasswordPage = () => {
  return (
    <Layout>
      <ResetPasswordForm passwordLoginEndpoint={passwordLoginEndpoint} />
    </Layout>
  );
};

export default ResetPasswordPage;
